var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1535.51 850",
    style: {
      enableBackground: "new 0 0 1535.51 850"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#028CC2;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#B1C0C9;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st3{fill:#0098CE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: -41.11,
    y1: 785.59,
    x2: 658.57,
    y2: 85.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 658.57,
    y1: 85.91,
    x2: 1035.54,
    y2: -291.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 651.22,
    y1: 963.06,
    x2: 1730.56,
    y2: -116.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M809.05,860.54L386.57,438.06c-22.12-22.12-55.23-24.87-73.95-6.15l-24.84,24.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1391.13,881.96l-317.2-317.2c-6.74-6.74-1.06-23.34,12.68-37.08l11.48-11.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M758.23-199.57l803.16,803.16c32.98,32.98,32.98,86.45,0,119.43l-160.22,160.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.9-167.27L567.43,58.26c32.81,32.81,32.81,85.99,0,118.8l-40.48,40.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 217.97,
    y1: -291.21,
    x2: 567.29,
    y2: 58.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -42.08,
    y1: 786.62,
    x2: 287.79,
    y2: 456.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1083.28,
    y1: 531,
    x2: 1730.56,
    y2: -116.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M511.4,557.19c-2.7-0.79-5.24,1.64-4.57,4.37l3.1,12.72l-9.09,8.68l-8.66-35.59 c-0.83-3.42,2.35-6.46,5.73-5.47l35.15,10.29l-9.09,8.68L511.4,557.19z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -13.15,
    y1: 37.42,
    x2: 473.11,
    y2: 523.68
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.8252b72e97bb5dba5a127ee99e94ded7.svg";
export { ForwardRef as ReactComponent };